module.exports = __webpack_public_path__ + "bd1a49ea797d138acc41d08e978a2ec7.jpg";